import { render, staticRenderFns } from "./MdIcon.vue?vue&type=template&id=49b42922&"
import script from "./MdIcon.vue?vue&type=script&lang=js&"
export * from "./MdIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports